import { Injectable } from '@angular/core';
import { PaymentTypeEnum } from '../models/payment-type.model';
import { PaymentSummary } from '../models/payment-summary.model';
import { PaymentService } from './payment.service';
import { PaymentMethod } from '../models/payment-method.model';
import { PaymentMethodUtils } from '../utils/payment-method-utils';

@Injectable({
  providedIn: 'root'
})
export class PaymentSummaryService {
  constructor(private paymentService: PaymentService) {}

  public calculateSummary(paymentType: PaymentTypeEnum, paymentMethod?: PaymentMethod | string): PaymentSummary {
    const {
      amountToPay: amount,
      totalAmount,
      biller,
      title,
      balance,
      commission,
      name,
      surname,
      email
    } = this.paymentService.payment;

    const commissionApplies = this.commissionApplies(paymentMethod);

    const paymentSummary: PaymentSummary = {
      amount,
      totalAmount: commissionApplies ? totalAmount : amount,
      paymentType,
      biller,
      title,
      balance,
      commission,
      commisionVisible: commissionApplies,
      personalData: {
        name,
        surname,
        email
      }
    };

    if (paymentType === PaymentTypeEnum.BALANCE) {
      paymentSummary.amount = balance.amountToPay;
      paymentSummary.totalAmount = commissionApplies ? balance.totalAmount : balance.amountToPay;
      paymentSummary.title = `Opłata za faktury (${balance.items.length})`;
    }

    return paymentSummary;
  }

  private commissionApplies(paymentMethod: PaymentMethod | string) {
    return (
      !!paymentMethod && !(PaymentMethodUtils.isBillGatewayApp(paymentMethod) || paymentMethod === PaymentMethod.SIMP)
    );
  }
}
